import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';

const MuiDialog = (props) => {
  const {
    children,
    ...restProps
  } = props;

  return (
    <Dialog
      fullWidth={true}
      scroll={'paper'}
      {...restProps}
    >
      {children}
    </Dialog>
  );
};

MuiDialog.propTypes = {
  // Dialog children, usually the included sub-components.
  children: PropTypes.node,
};

// *************************************
// STYLED COMPONENTS                              
// *************************************

// Dialog
export const StyledDialog = styled(MuiDialog)`
  .MuiDialog-paperWidthXs {
    max-width: 350px;
    border-radius: 6px;
  }

  .MuiDialog-paperWidthSm {
    max-width: 500px;
    border-radius: 6px;
  }

  .MuiDialog-paperWidthMd {
    max-width: 800px;
    border-radius: 6px;
  }

  .MuiDialog-paperWidthLg {
    max-width: 1000px;
    border-radius: 6px;
  }

  .MuiDialog-paperWidthXl {
    max-width: 1300px;
    border-radius: 6px;
  }
`;

// Dialog Title
export const StyledDialogTitle = styled(DialogTitle)`
  &.MuiDialogTitle-root {
    height: 65px;
    padding: 16px; 
    display: flex;
    border-bottom: 1px solid ${(props) => props.theme.colors.greyLight};
  }

  .MuiTypography-root {
    font-family: 'Bryant Pro Medium';
    font-size:  ${(props) => props.theme.typography.heading5};
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.colors.greyDark}
  }
`;

// Dialog Content
export const StyledDialogContent = styled(DialogContent)`
  &.MuiDialogContent-root {
    color: ${(props) => props.theme.colors.greyDark};
    padding: 16px;
    scrollbar-width: thin !important;
  }
`;

// Dialog Actions
export const StyledDialogActions = styled(DialogActions)`
  &.MuiDialogActions-root {
    padding: 8px 16px;
    border-top: 1px solid ${(props) => props.theme.colors.greyLight};
  }
`;

// Dialog BoxIcon (optional) 
export const StyledDialogBoxIcon = styled.div`
  display: flex;
  align-items: center;
  padding-right: 16px;

  .MuiSvgIcon-root {
    font-size: 20px;
  }
`;

// Dialog BoxClose
export const StyledDialogBoxClose = styled(IconButton)`
  &.MuiIconButton-root {
    position: absolute;
    right: 8px;
    padding: 8px;
    color: ${(props) => props.theme.colors.greyDark};
    &:hover {
      background-color: ${(props) => props.theme.colors.greyHover};;
    }
  }

  .MuiSvgIcon-root {
    font-size: 20px;
  }
`;
